<div class="products-group" *ngIf="productsData">
    <finder-component-header [data]="productsData"></finder-component-header>
    <div class="products-group-items">
        <div class="product" *ngFor="let product of productsData.products">
            <a [href]="product.url">
                <finder-picture
                    [picture]="product.picture"
                ></finder-picture>
                <h3 [class]="product.cssClasses">
                    {{product.title}}
                </h3>
            </a>
        </div>
    </div>
</div>
